__turbopack_context__.v({
  "mark": "VerifiedMark-module-scss-module__T2IfLq__mark",
});
